import { VIEW_H, VIEW_W } from "@/game/config";
import StreamScene from "@/game/phaser/scenes/StreamScene";
import { SpinePlugin } from "@esotericsoftware/spine-phaser-v4/dist/SpinePlugin";
import { useEffect } from "react";
import { useGameRuntime } from "../context/GameContext";

interface PhaserCanvasProps {
  phaserMountRef: React.RefObject<HTMLDivElement | null>;
}

const PhaserCanvas = ({ phaserMountRef }: PhaserCanvasProps) => {
  const runtime = useGameRuntime();

  useEffect(() => {
    if (!phaserMountRef.current) return;

    const config: Phaser.Types.Core.GameConfig = {
      type: Phaser.WEBGL,
      parent: phaserMountRef.current,
      width: VIEW_W,
      height: VIEW_H,
      backgroundColor: "#2d2d44",
      antialias: true,
      scene: [StreamScene],
      plugins: {
        scene: [
          {
            key: "SpinePlugin",
            plugin: SpinePlugin,
            mapping: "spine",
            systemKey: "SpinePlugin",
            sceneKey: "spine",
            start: true,
          },
        ],
      },
      callbacks: {
        postBoot: (game) => {
          const scene = game.scene.keys["StreamScene"] as StreamScene;
          scene.scene.start("StreamScene", { runtime });
        },
      },
      scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
      },
    };

    const game = new Phaser.Game(config);

    return () => {
      game.destroy(true);
    };
  }, []);

  return <div ref={phaserMountRef} className="w-full h-full select-none" />;
};

export default PhaserCanvas;
